import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Lang from "../lang/translations";
import Auth from "../../userServices/authServices";
import helpers from "../_helpers/helpersFunction";
import Context from "../context/context";
const config = require("../_helpers/configServizi");

export default function Signup(props) {
  const context = useContext(Context);
  const location = useLocation();
  const fbPrefill = location.state?.fbPrefill;

  const [formData, setFormData] = useState({
    email: fbPrefill?.email || "",
    password: "",
    geo: "",
    age: "",
    terms1: false,
    terms2: false,
    terms3: false,
    terms4: false,
    terms5: false,
    sono: 0,
    cerco: 0,
  });

  const [errors, setErrors] = useState({});
  const [spinner, setSpinner] = useState(false);
  const [regioni, setRegioni] = useState([]);
  const [ages, setAges] = useState(getAges());
  const [errore, setErrore] = useState("");

  const navigate = useNavigate();

  const conAvvisoPixel = [
    "chateincontri.com",
    "flirtincontri.com",
    "incontrisenzalimiti.com",
    "incontrisenzafreni.com",
    "looviing.com",
    "staging.yatequiero.com",
    "localhost",
  ].includes(window.location.hostname);

  useEffect(() => {
    helpers.getRegionsByCountry().then((res) => {
      setRegioni(res);
    });
  }, []);

  function getAges() {
    const ages = [];
    for (let i = 19; i < 99; i++) {
      ages.push(i);
    }
    return ages;
  }

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  function handleInputChange(e) {
    const { name, value, checked, type } = e.target;
console.log(name, value, checked, type)
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));

    const newErrors = { ...errors };

    if (name === "email") {
      newErrors.email = !value || !validateEmail(value);
    } else if (name === "password") {
      newErrors.password = !value;
    } else if (name === "geo") {
      newErrors.geo = !value;
    } else if (name === "eta") {
      newErrors.eta = !value;
    } else if (["terms1", "terms2", "terms3", "terms4"].includes(name)) {
      newErrors[name] = !checked;
    } else if (name === "sono") {
      newErrors.sono = value === 0;
    } else if (name === "cerco") {
      newErrors.cerco = value === 0;
    }

    setErrors(newErrors);
  }

  function checkErrori() {
    const newErrors = {};
  
    // Verifica i campi in ordine di priorità
    if (!formData.email || !validateEmail(formData.email)) {
      newErrors.email = true;
      setErrore(Lang({ w: "errore_email", page: "signupForm" }));
      setErrors(newErrors);
      return true; // Interrompe la verifica e mostra solo il primo errore
    }
  
    if (!formData.password) {
      newErrors.password = true;
      setErrore(Lang({ w: "errore_password", page: "signupForm" }));
      setErrors(newErrors);
      return true;
    }
  
    if (!formData.eta) {
      newErrors.eta = true;
      setErrore(Lang({ w: "eta", page: "signupForm" })); // Chiave per errore età
      setErrors(newErrors);
      return true;
    }
  
    if (!formData.geo) {
      newErrors.geo = true;
      setErrore(Lang({ w: "errore_citta", page: "signupForm" }));
      setErrors(newErrors);
      return true;
    }
  
    if (formData.sono === 0) {
      newErrors.sono = true;
      setErrore(Lang({ w: "errore_sono", page: "signupForm" }));
      setErrors(newErrors);
      return true;
    }
  
    if (formData.cerco === 0) {
      newErrors.cerco = true;
      setErrore(Lang({ w: "errore_cerco", page: "signupForm" }));
      setErrors(newErrors);
      return true;
    }
  
    if (!formData.terms1 || !formData.terms2 || !formData.terms3 || !formData.terms4 || !formData.terms5) {
      newErrors.terms1 = !formData.terms1;
      newErrors.terms2 = !formData.terms2;
      newErrors.terms3 = !formData.terms3;
      newErrors.terms4 = !formData.terms4;
      newErrors.terms5 = !formData.terms5;

      setErrore(Lang({ w: "errore_terms", page: "signupForm" }));
      setErrors(newErrors);
      return true;
    }
  
    // Se non ci sono errori
    setErrors(newErrors);
    setErrore("");
    return false;
  }

  const onSubmit = (e) => {
    e.preventDefault();

    if (checkErrori()) {
      setSpinner(false);
      return;
    }

    setSpinner(true);
    setErrore("");

    const data = {
      ...formData,
      source: localStorage.getItem("source") || null,
      country: localStorage.getItem("country") || helpers.getCountry(),
      campid: localStorage.getItem("campid") || "",
      ip: localStorage.getItem("ip") || null,
      clickid: localStorage.getItem("trackerId"),
      fingerprint: localStorage.getItem("fingerprint"),
      ua: navigator.userAgent,
      fluxId: context.fluxId || config.servizi[window.location.hostname].default_fluxid,
      servizio: window.location.hostname,
      sono: formData.sono === 1 ? "donna" : "uomo",
      cerco: formData.cerco === 1 ? "donna" : "uomo",
      region: formData.geo
    };

    Auth.register(data, context)
      .then((res) => {
        if (res.token) {
            helpers.setUser(res, context, true, true);
            navigate("/")

          if(res.flusso.optin == "doi"){
            helpers.showPopuphook("doi",context,res)
            return
          }

        } else {
          setErrore(helpers.errorCodes(res));
          setSpinner(false);
        }
      })
      .catch((err) => {
        helpers.logToBackend("problemi su signup", { err: err.message, clickid: localStorage.getItem("trackerId") });
        setSpinner(false);
      });
  };

  function Spinner() {
    return spinner ? (
      <div className="spinner-border text-light" role="status">
        <span className="sr-only">
          <Lang w={"caricando"} page={"signupForm"} />
        </span>
      </div>
    ) : null;
  }

  return (
    <div>
      <h1 className="uppercase">
        <Lang w={"registrati_adesso"} page={"popupHook"} />
      </h1>
      <form className={"formSignup"} onSubmit={onSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleInputChange}
          className={errors.email ? "errorCardInput" : ""}
        />

        <input
          type="password"
          name="password"
          placeholder={Lang({ w: "scegli_una_password", page: "signupForm", var: true })}
          value={formData.password}
          onChange={handleInputChange}
          className={errors.password ? "errorCardInput" : ""}
        />

        <select name="eta" onChange={handleInputChange} className={errors.eta ? "errorCardInput" : ""}>
          <option selected disabled>
            {Lang({ w: "eta", page: "signupForm", var: true })}
          </option>
          {ages.map((el) => (
            <option key={el} value={el}>
              {el}
            </option>
          ))}
        </select>

         <div className="row">
              <div className="col">
                  <label><Lang w={"sono"} page={"signupForm"}/></label>
                  <span  onClick={() => setFormData({ ...formData, sono: 1 })} className={formData.sono  ==1 ? ("selectedSex iconForm"):("iconForm")}><i className="fas fa-female"></i></span>
                  <span onClick={() => setFormData({ ...formData, sono: 2 })} className={formData.sono ==2 ? ("selectedSex iconForm"):("iconForm")}><i className="fas fa-male"></i></span>
              </div>
              <div className="col">
                  <label><Lang w={"cerco"} page={"signupForm"}/></label>
                  <span onClick={() => setFormData({ ...formData, cerco: 1 })} className={formData.cerco ==1 ? ("selectedSex iconForm"):("iconForm")}><i className="fas fa-female"></i></span>
                  <span onClick={() => setFormData({ ...formData, cerco: 2 })} className={formData.cerco ==2 ? ("selectedSex iconForm"):("iconForm")}><i className="fas fa-male"></i></span>
              </div>
          </div>

        <select name="geo" onChange={handleInputChange} className={errors.geo ? "errorCardInput" : ""}>
          <option selected disabled hidden value="">
            {Lang({ w: "regione", page: "signupForm", var: true })}*
          </option>
          {regioni.map((el) => (
            <option key={el} value={el}>
              {el}
            </option>
          ))}
        </select>

        <Spinner />

        <div className="form-group">
          
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="terms1"
              checked={formData.terms1}
              onChange={handleInputChange}
            />
            <label className={`form-check-label ${errors.terms1 ? "text-danger" : ""}`}>
              <Lang
                w={"accetto_clausole"}
                page={"signupForm"}
                placeholders={{ terms: config.servizi[window.location.hostname].legal_link?.termini }}
              />
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="terms2"
              checked={formData.terms2}
              onChange={handleInputChange}
            />
            <label className={`form-check-label ${errors.terms2 ? "text-danger" : ""}`}>
              <Lang
                w={conAvvisoPixel ? "acconsento_trattamento_pixel" : "acconsento_trattamento"}
                page={"signupForm"}
                placeholders={{ privacy: config.servizi[window.location.hostname].legal_link?.privacy }}
              />
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="terms3"
              checked={formData.terms3}
              onChange={handleInputChange}
            />
            <label className={`form-check-label ${errors.terms3 ? "text-danger" : ""}`}>
              <Lang
                w={conAvvisoPixel ? "acconsento_comunicazione_pixel" : "acconsento_comunicazione"}
                page={"signupForm"}
                placeholders={{ privacy: config.servizi[window.location.hostname].legal_link?.privacy }}
              />
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="terms4"
              checked={formData.terms4}
              onChange={handleInputChange}
            />
            <label className={`form-check-label ${errors.terms4 ? "text-danger" : ""}`}>
              <Lang w={"dichiaro_maggiorenne"} page={"signupForm"} />
            </label>
          </div>

          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              name="terms5"
              checked={formData.terms5}
              onChange={handleInputChange}
            />
            <label className={`form-check-label ${errors.terms5 ? "text-danger" : ""}`}>
              <Lang w={"orientamenti_sessuali"} page={"signupForm"} placeholders={{ privacy: config.servizi[window.location.hostname].legal_link?.privacy }} />
            </label>
          </div>
          
         <span className="last_disclaimer">
           <Lang
                w={"cliccando_accetti"}
                page={"signupForm"}
                placeholders={{ privacy: config.servizi[window.location.hostname].legal_link?.privacy, terms: config.servizi[window.location.hostname].legal_link?.termini}}
              />
         </span>


        </div>

        {errore && <p className="erroreSignup">{errore}</p>}
        <input
          type="submit"
          value={Lang({ w: "registrati_gratis", page: "signupForm", var: true })}
          disabled={spinner}
        />
      </form>
    </div>
  );
}